import {RefObject, useEffect, useRef} from 'react';
import {trackEvent} from './posthog';

export const useTrackOnView = (
    ref: RefObject<Element>,
    event: string,
    properties: Record<string, string | number | boolean | null | undefined> = {},
    threshold = 0.4
) => {
    const tracked = useRef(false);

    useEffect(() => {
        const element = ref.current;
        if (!element || tracked.current) return;

        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting && !tracked.current) {
                tracked.current = true;
                trackEvent(event, properties);
                observer.disconnect();
            }
        }, {threshold});

        observer.observe(element);
        return () => observer.disconnect();
    }, [event, properties, ref, threshold]);
};
